<template>
  <div class="order-confirmation-short-id-wrapper">
    <div
      v-if="error_message"
      class="error-message"
    >
      <h2>Error Loading Confirmation</h2>
      <p>{{ error_message }}</p>
    </div>

    <iframe
      v-else-if="widget_src"
      ref="widget-iframe"
      :src="widget_src"
      class="widget-iframe"
      frameborder="0"
      @load="onIframeLoad"
    ></iframe>
    <div
      v-else
      class="loading-message"
    >
      <h2>Loading Order Confirmation...</h2>
    </div>
  </div>
</template>

<script>
import { buildWidgetUrl } from '@/js/widget/widget-url-builder.js';
import { PARENT_TO_WIDGET } from "@/js/widget/widget-messaging.js";
import NoIndexPage from '@/mixins/noindex-page.js';

export default {
  name: 'OrderConfirmationShortIdWrapper',

  mixins: [NoIndexPage],

  data() {
    return {
      is_iframe_loaded: false,
      short_id: null,
      settings_id: null,
      error_message: null
    };
  },

  computed: {
    widget_src() {
      const current_params = new URLSearchParams(window.location.search);
      const params = {};

      for (const [key, value] of current_params) {
        if (key !== 'short_id' && key !== 'settings_id') {
          params[key] = value;
        }
      }

      return buildWidgetUrl('order-confirmation', params, 5176);
    }
  },

  mounted() {
    const url_params = new URLSearchParams(window.location.search);
    this.settings_id = url_params.get("settings_id");
    this.short_id = this.$route.params.short_id || url_params.get("short_id");

    if (!this.short_id && !this.settings_id) {
      this.error_message = "No order confirmation ID or settings ID provided in the URL.";
      return;
    }
  },

  methods: {
    onIframeLoad() {
      this.is_iframe_loaded = true;

      if (this.error_message) {
        return;
      }


      if (this.short_id) {
        this.loadProductionModeData();
      }
    },


    loadProductionModeData() {
      const success_handler = (response) => {
        const confirmation_data = response.confirmation;
        const form_data = response.settings;
        this.sendProductionData(form_data, confirmation_data);
      };

      const error_handler = (error) => {
        const error_message = (error && error.message) ? error.message : (typeof error === 'string' ? error : "Failed to load order confirmation data");
        this.error_message = error_message;
        this.postMessageToWidget({ error: error_message, form: null, params: null });
      };

      // Single API call that validates signature automatically
      const endpoint = `GET: api/v1/public/order-confirmation/${this.short_id}`;

      this.$rc.rest({
        spinner: true,
        endpoint: endpoint,
        on_success: success_handler,
        on_error: error_handler
      });
    },

    sendProductionData(form_data, confirmation_data) {
      const url_params = new URLSearchParams(window.location.search);
      const payload = {
        form: form_data,
        order_data: {
          order_number: confirmation_data.order_number || "",
          order_id: confirmation_data.order_id || "",
          first_name: confirmation_data.first_name || "",
          last_name: confirmation_data.last_name || "",
          email_address: confirmation_data.email_address || "",
          endpoint: confirmation_data.endpoint || "",
          ship_to_address: confirmation_data.ship_to_address || "",
          bill_to_address: confirmation_data.bill_to_address || "",
          state: confirmation_data.state || "pending",
          publish_signature_id: form_data.publish_signature_id || "",
        },
        params: {
          short_id: this.short_id,
          order_confirmation_settings_id: confirmation_data.order_confirmation_settings_id,
          is_test_mode: false,
          mobile_breakpoint: url_params.get("mobile") === "true" ? 0 : 600,
        },
      };
      this.postMessageToWidget(payload);
    },

    postMessageToWidget(data) {
      const iframe = this.$refs['widget-iframe'];
      if (!iframe || !iframe.contentWindow) {
        return;
      }

      const message = [
        PARENT_TO_WIDGET.SET_SETTINGS,
        data
      ];

      iframe.contentWindow.postMessage(message, '*');
    }
  }
};
</script>

<style scoped>
.order-confirmation-short-id-wrapper {
  width: 100%;
  height: 100vh;
  overflow: hidden;
}

.widget-iframe {
  width: 100%;
  height: 100%;
  border: none;
}

.error-message,
.loading-message {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: 100vh;
  text-align: center;
  padding: 20px;
}

.error-message h2,
.loading-message h2 {
  color: #333;
  margin-bottom: 16px;
}

.error-message p {
  color: #666;
  max-width: 500px;
}
</style>